module.exports = __webpack_public_path__ + "img/9.9e6f88e5.webp";